import React, { FC, ReactNode } from 'react';

import { authService } from 'services';
import { useLang, useMutation } from 'hooks';
import { Button, Paragraph, ResultIcon, Title } from 'components/ui';

import styles from './styles.module.css';

type StatusViewProps = {
  type: 'error' | 'success',
  title: ReactNode;
  caption: ReactNode;
};

const StatusView: FC<StatusViewProps> = ({ type, title, caption }) => {
  const lang = useLang();

  const logoutMutation = useMutation({
    mutationFn: authService.logout,
  });

  return (
    <div className={styles.statusInfo}>
      <ResultIcon className={styles.statusInfo__icon} type={type} />
      <Title className={styles.statusInfo__title}>{title}</Title>
      <Paragraph className={styles.statusInfo__caption} type="secondary">{caption}</Paragraph>
      <Button
        className={styles.statusInfo__button}
        block
        loading={logoutMutation.isPending}
        onClick={() => logoutMutation.mutateAsync()}
      >
        {lang.get('common.actions.ok')}
      </Button>
    </div>
  );
};

export default StatusView;
